import {
    SonoraHintViewState,
    SonoraEntityType,
    SonoraViewState,
    SonoraHintType,
} from 'owa-editor-sonora-types';
import { EntityType } from '@augloop-types/honeybee';
import type { IPoint } from '@fluentui/react';
import { mutatorAction } from 'satcheljs';
import { logSimpleSonoraDatapoint } from '../dataLogger/logSonoraDatapoint';

export const updateIntentDetectionHint = mutatorAction(
    'updateIntentDetectionHint',
    (viewState: SonoraHintViewState, entityType: EntityType) => {
        let sonoraEntityType: SonoraEntityType;
        switch (entityType) {
            case EntityType.File:
                sonoraEntityType = SonoraEntityType.File;
                break;
            case EntityType.MeetingAvailability:
                sonoraEntityType = SonoraEntityType.MeetingTimes;
                break;
            default:
                return;
        }
        viewState.selectedType = sonoraEntityType;
        viewState.intentDetectionHintShown.add(sonoraEntityType);
        viewState.intentDetectionHintCurrentlyShowing = sonoraEntityType;
    }
);

export const resetIntentDetectionHintCurrentlyShowing = mutatorAction(
    'resetIntentDetectionHintCurrentlyShowing',
    (viewState: SonoraHintViewState) => {
        delete viewState.intentDetectionHintCurrentlyShowing;
    }
);

export const updateIntentDetectionHintAccepted = mutatorAction(
    'updateIntentDetectionHintAccepted',
    (viewState: SonoraHintViewState, intentDetectionHintAccepted: SonoraEntityType | undefined) => {
        viewState.intentDetectionHintAccepted = intentDetectionHintAccepted;
    }
);

export const showTeachingBubble = mutatorAction(
    'showTeachingBubble',
    (viewState: SonoraHintViewState, text: string, target?: IPoint) => {
        viewState.shouldShowTeachingBubble = true;
        viewState.teachingBubbleText = text;
        if (target) {
            viewState.teachingBubbleTarget = target;
        }
        viewState.teachingBubbleDisplayTime = Date.now();
    }
);

export const hideTeachingBubble = mutatorAction(
    'hideTeachingBubble',
    (viewState: SonoraViewState, triggerCharacter: string, dismissTrigger: string) => {
        if (viewState.shouldShowTeachingBubble) {
            viewState.shouldShowTeachingBubble = false;

            logSimpleSonoraDatapoint('SonoraIntentDetectionHintDismissed', {
                sessionId: viewState.sessionId,
                entityType:
                    viewState.selectedType != undefined
                        ? SonoraEntityType[viewState.selectedType]
                        : undefined,
                triggerCharacter: triggerCharacter,
                hintType: SonoraHintType[SonoraHintType.TeachingBubble],
                dismissTrigger: dismissTrigger,
                persistTime: viewState.teachingBubbleDisplayTime
                    ? Date.now() - viewState.teachingBubbleDisplayTime
                    : undefined,
            });

            delete viewState.intentDetectionHintCurrentlyShowing;
            delete viewState.teachingBubbleDisplayTime;
        }
    }
);

export const resetTeachingBubbleTimer = mutatorAction(
    'resetTeachingBubbleTimer',
    (viewState: SonoraHintViewState, timerId: number) => {
        if (viewState.teachingBubbleTimerId) {
            window.clearTimeout(viewState.teachingBubbleTimerId);
        }
        viewState.teachingBubbleTimerId = timerId;
    }
);
